import { PostDisplay } from '$types';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-moderator[post]',
  templateUrl: './moderator.component.html',
  styleUrls: ['./moderator.component.css']
})
export class ModeratorComponent {
  validateFree() {
    this.post.admin = {free : true};
    this.validatePost.emit(this.post)
  }
  validate() {
    this.validatePost.emit(this.post)
  }
  @Input() post!: PostDisplay;
  @Output() validatePost = new EventEmitter<PostDisplay>();
  @Output() invalidatePost = new EventEmitter<PostDisplay>();
  @Output() updatePost = new EventEmitter<PostDisplay>();
  @Output() deletePost = new EventEmitter<PostDisplay>();
}
